import { FC, useRef } from 'react'
import classNames from 'classnames'
import { Icon, WhenShow } from 'mk-pc'
import { FilePreview } from 'mk-biz-pc'
import { getFileCode } from './service'
import './index.scss'
import { useMessage } from '@mkmp/core'

interface BaseFileListProps {
  bizType?: string
  rowNum?: number
  files: Array<any>
}

/**
 * 文件列表
 * @param props
 * @returns
 */
export const FileList: FC<BaseFileListProps> = (props) => {
  const { messageApi } = useMessage()
  const { rowNum, bizType = '', files = [] } = props
  const previewRef = useRef<any>(null)

  const className = classNames('attachlist-show', {
    row1: rowNum === 1,
    row2: rowNum === 2,
    row3: rowNum === 3
  })

  /**
   * 文件预览
   * @param id
   */
  const handlePreview = async (id: string) => {
    const code = await getFileCode(id, 'preview', bizType)
    if (previewRef.current) {
      previewRef.current.open(code)
    }
  }

  /**
   * 文件下载
   * @param id
   * @param fileName
   */
  const handleDownload = async (id: string, fileName: string) => {
    if (!id) {
      return messageApi.open({
        type: 'warning',
        duration: 1,
        content: '获取文件信息失败，请核对'
      })
    }

    const a = document.createElement('a')
    a.href = `${process.env.API_ADMIN_URL}/file/download-file/${id}` // 下载接口地址
    a.download = fileName
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  return (
    <>
      <ul className={className}>
        {files.map((file: any) => (
          <li key={file.id} className="attachlist-show__item">
            <span className="file-icon"></span>
            <div className="text">
              <p>{file.fileName}</p>
            </div>
            <div className='attachlist-show__item-btns'>
              <WhenShow when={['pdf', 'image'].includes(file.fileType)}>
                <Icon name="icon-browse" size="18" onClick={() => handlePreview(file.id)} />
              </WhenShow>
              <Icon name="icon-download" size="18" onClick={() => handleDownload(file.fileId, file.fileName)} />
            </div>
          </li>
        ))}
      </ul>
      <FilePreview ref={previewRef} getContainer={() => document.querySelector('.shell-app')} />
    </>
  )
}
